// import axios from "axios";
// import apiConfig from "../config/api.config";
// import { message } from "antd";
// import store from "../state/store";
// axios.defaults.withCredentials = true
// const { baseURL, auth, secure, NODE_ENV } = apiConfig;
// const ExecRequest = (config, options = { secure: true, multipart: false }) => {

//   function promiseCallback(resolve) {
//   const state = store.getState();

// const token = state.user?.token;
// const tenantId = state.user?.tenantId;

// let headers = {
//   "Content-Type": options.multipart
//     ? "multipart/form-data"
//     : "application/json",
// };

// if (options.secure) {
//   headers = {
//     ...headers,
//     Authorization: `Bearer ${token}`,
//     "x-tenant-id": tenantId,
//   };
// }
//     config.url = `${baseURL}${options.secure ? secure : auth}${config.url}`;
//     axios({ ...config, headers: headers })
//       .then((res) => {
//         const errCode = res.resCode;
//         const data = res.data;
//         const responseStatus = res.status;

//         if (errCode === -1) {
//           resolve(data.msg);
//         } else if (errCode === 2061) {
//           resolve(data.msg);
//           message.success(data.msg);
//         } else if (errCode === 2601) {
//           resolve(data);
//         } else {
//           resolve(data);
//         }
//       })
//       .catch((error) => {
        
//         message.destroy();
//         if (error.response) {
//           const status = error.response.status;
//           const responseCode = error.response.data?.resCode;

//           if (responseCode === 9) {
//             window.location.replace("/");
//           }

//           resolve(error.response.data);
//         } else if (error.request) {
//           message.error("Unable to reach the server. Please check your internet or try again later.");
//         } else {
//           message.error(`${error.name}: ${error.message}`);
//         }
//         resolve(null);
//       });
//   }
//   return new Promise(promiseCallback);
// };

// export default {
//   get: async (endPoint, options = { secure: true, multipart: false }) => {
//     options = options.multipart
//       ? options
//       : {
//         ...options,
//         multipart: false,
//       };
//     let result = await ExecRequest(
//       {
//         method: "get",
//         url: endPoint,
//       },
//       options
//     );

//     return !result ? [] : result;
//   },
//   post: async (
//     endPoint,
//     dataBody,
//     options = { secure: true, multipart: false }
//   ) => {
//     options = options.multipart
//       ? options
//       : {
//         ...options,
//         multipart: false,
//       };
//     let result = await ExecRequest(
//       {
//         method: "post",
//         url: endPoint,
//         data: dataBody,
//       },
//       options
//     );
//     return !result ? [] : result;
//   },
//   put: async (
//     endPoint,
//     dataBody,
//     options = { secure: true, multipart: false }
//   ) => {
//     options = options.multipart
//       ? options
//       : {
//         ...options,
//         multipart: false,
//       };
//     let result = await ExecRequest(
//       {
//         method: "put",
//         url: endPoint,
//         data: dataBody,
//       },
//       options
//     );

//     return !result ? [] : result;
//   },

//   delete: async (endPoint, options = { secure: true }) => {
//     let result = await ExecRequest(
//       {
//         method: "delete",
//         url: endPoint,
//       },
//       options
//     );

//     return !result ? [] : result;
//   }
// };


import axios from "axios";
import apiConfig from "../config/api.config";
import { message } from "antd";
// REMOVED: import store from "../state/store";

// NEW: store is injected from index.js to avoid the circular import
let store = null;
export const injectStore = (_store) => {
  store = _store;
};

axios.defaults.withCredentials = true;
const { baseURL, auth, secure, NODE_ENV } = apiConfig;
const ExecRequest = (config, options = { secure: true, multipart: false }) => {

  function promiseCallback(resolve) {
    const state = store?.getState?.() || {}; // CHANGED: safe if store is not injected yet

    const token = state.user?.token;
    const tenantId = state.user?.tenantId;

    let headers = {
      "Content-Type": options.multipart
        ? "multipart/form-data"
        : "application/json",
    };

    if (options.secure) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant-id": tenantId,
      };
    }
    config.url = `${baseURL}${options.secure ? secure : auth}${config.url}`;
    axios({ ...config, headers: headers })
      .then((res) => {
        const errCode = res.resCode;
        const data = res.data;
        const responseStatus = res.status;

        if (errCode === -1) {
          resolve(data.msg);
        } else if (errCode === 2061) {
          resolve(data.msg);
          message.success(data.msg);
        } else if (errCode === 2601) {
          resolve(data);
        } else {
          resolve(data);
        }
      })
      .catch((error) => {

        message.destroy();
        if (error.response) {
          const status = error.response.status;
          const responseCode = error.response.data?.resCode;

          if (responseCode === 9) {
            window.location.replace("/");
          }

          resolve(error.response.data);
        } else if (error.request) {
          message.error("Unable to reach the server. Please check your internet or try again later.");
        } else {
          message.error(`${error.name}: ${error.message}`);
        }
        resolve(null);
      });
  }
  return new Promise(promiseCallback);
};

export default {
  get: async (endPoint, options = { secure: true, multipart: false }) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    let result = await ExecRequest(
      {
        method: "get",
        url: endPoint,
      },
      options
    );

    return !result ? [] : result;
  },
  post: async (
    endPoint,
    dataBody,
    options = { secure: true, multipart: false }
  ) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    let result = await ExecRequest(
      {
        method: "post",
        url: endPoint,
        data: dataBody,
      },
      options
    );
    return !result ? [] : result;
  },
  put: async (
    endPoint,
    dataBody,
    options = { secure: true, multipart: false }
  ) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    let result = await ExecRequest(
      {
        method: "put",
        url: endPoint,
        data: dataBody,
      },
      options
    );

    return !result ? [] : result;
  },

  delete: async (endPoint, options = { secure: true }) => {
    let result = await ExecRequest(
      {
        method: "delete",
        url: endPoint,
      },
      options
    );

    return !result ? [] : result;
  }
};